import { useAtomValue } from 'jotai';
import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '~/components/section-title';
import { TopicCard } from '~/components/topic-card';
import { ModuleType } from '~/utils/module-type';
import { ViewTracker } from '~/components/view-tracker';
import { Topic } from 'shared/models/legacy';
import { SeeMore } from '~/components/see-more';
import { $HashtagRelated } from 'shared/atoms';
import { $CurrentPageModule } from '~/models/current-page-module';
import { ScopedProvider } from '@lemon8/web-app-shared/ssr';
import { $CurrentHashtagId } from '~/routes/topic.$hashtag_id/shared/atoms';
import { $CurrentPositionPrefix } from '~/models/current-position-prefix';
import { ClickPositionPrefix } from '~/utils/click-position';
import { $CurrentModuleRank } from '~/models/current-module-rank';

const FOLDED_TOPIC_COUNT = 10;

export const HashtagTopicSection: FC = () => {
  const { t } = useTranslation();
  const hashtagId = useAtomValue($CurrentHashtagId);
  const data = useAtomValue($HashtagRelated(hashtagId));
  const relatedTopics = data.items;
  const relatedSugs = data.sugWords;
  const topics = [...relatedTopics, ...relatedSugs];

  const [fold, setFold] = useState(topics.length > FOLDED_TOPIC_COUNT);

  const sendTrackingEvent = useCallback(() => {
    window.Tea('wap_module_show', {
      current_page_module: ModuleType.related_topic,
      page_id: hashtagId,
    });
  }, []);

  const handleSeeMore = useCallback(() => {
    setFold(false);
  }, []);

  if (!topics.length && !relatedSugs.length) {
    return null;
  }

  return (
    <ViewTracker key="hashtag-topic" onView={sendTrackingEvent}>
      <section id="hashtag-related-topic">
        <ScopedProvider
          atomsWithHydration={[
            [$CurrentPageModule, ModuleType.related_topic],
            [$CurrentPositionPrefix, ClickPositionPrefix.none],
            [$CurrentModuleRank, -1],
          ]}
        >
          <SectionTitle title={t('wap_seo_recoomend_topic')} />
          {topics.slice(0, fold ? FOLDED_TOPIC_COUNT : Number.MAX_SAFE_INTEGER).map((topic: Topic | string) => (
            <TopicCard key={typeof topic === 'string' ? topic : topic.topicId} topic={topic} />
          ))}
          {fold && topics.length > FOLDED_TOPIC_COUNT && <SeeMore onClickSeeMore={handleSeeMore} />}
        </ScopedProvider>
      </section>
    </ViewTracker>
  );
};
